var setCache = function setCache(key, value) {
  if (typeof window === "undefined") return;
  if (!window.__BILI_X_ENGINE_SCRIPT_CACHE__) {
    window.__BILI_X_ENGINE_SCRIPT_CACHE__ = {};
  }
  window.__BILI_X_ENGINE_SCRIPT_CACHE__[key] = value;
};
var getCache = function getCache(key) {
  if (typeof window === "undefined") return null;
  if (!window.__BILI_X_ENGINE_SCRIPT_CACHE__) {
    return null;
  }
  return window.__BILI_X_ENGINE_SCRIPT_CACHE__[key] || null;
};
var removeCache = function removeCache(key) {
  if (typeof window === "undefined") return;
  if (!window.__BILI_X_ENGINE_SCRIPT_CACHE__) {
    return;
  }
  if (typeof window.__BILI_X_ENGINE_SCRIPT_CACHE__[key] !== "undefined") {
    delete window.__BILI_X_ENGINE_SCRIPT_CACHE__[key];
  }
};
var loadScript = function loadScript(src, config) {
  if (typeof window === "undefined") return Promise.reject(new Error("window is not defined"));
  // cache
  src = src.replace(/^https?:\/\//, "//");
  var cacheKey = src;
  var cache = getCache(cacheKey);
  if (cache != null && cache.promise) return cache.promise;
  // create promise
  var promise = new Promise(function (resolve, reject) {
    var script = document.createElement("script");
    script.src = src;
    if (config != null && config.behavior) {
      script.setAttribute(config.behavior, "");
    }
    script.onload = function () {
      var global = window;
      if (config.lib) {
        if (global[config.lib]) return resolve(global[config.lib]);
        return reject(new Error("Failed to access library \"" + config.lib + "\" from " + src));
      }
      resolve(null);
    };
    script.onerror = function () {
      reject(new Error("Failed to load " + src));
      document.head.removeChild(script);
    };
    document.head.appendChild(script);
  });
  // cache
  setCache(cacheKey, {
    promise: promise,
    lib: config == null ? void 0 : config.lib
  });
  promise.then(function () {
    if ((config == null ? void 0 : config.cache) !== false) return;
    removeCache(cacheKey);
  })["catch"](function () {
    if ((config == null ? void 0 : config.cache) !== false) return;
    removeCache(cacheKey);
  });
  return promise;
};

var loadKvSDK = function loadKvSDK() {
  try {
    if (window.KvSDK) {
      return Promise.resolve(window.KvSDK);
    }
    return Promise.resolve(loadScript("//s1.hdslb.com/bfs/seed/jinkela/kv-sdk/index.js", {
      lib: "KvSDK"
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};
var useKv = function useKv(cfg) {
  return Promise.resolve(loadKvSDK()).then(function (KvSDK) {
    return new KvSDK(cfg);
  });
};
var useKvSync = function useKvSync(cfg) {
  if (!window.KvSDK) {
    return null;
  }
  return new window.KvSDK(cfg);
};

var loadMiniLogin = function loadMiniLogin() {
  try {
    if (window.MiniLogin) {
      return Promise.resolve(window.MiniLogin);
    }
    return Promise.resolve(loadScript("//s1.hdslb.com/bfs/seed/jinkela/short/mini-login/miniLogin.umd.min.js", {
      lib: "MiniLogin"
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};
var loadBiliUser = function loadBiliUser() {
  try {
    return Promise.resolve(loadScript("//s1.hdslb.com/bfs/seed/jinkela/short/bili-user/index.js", {
      lib: "__BiliUser__"
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};
var useAuthData = function useAuthData() {
  try {
    var _temp2 = function _temp2() {
      return Promise.resolve(window.__BiliUser__.get());
    };
    var _temp = function () {
      if (!window.__BiliUser__) {
        return Promise.resolve(loadBiliUser()).then(function () {});
      }
    }();
    return Promise.resolve(_temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp));
  } catch (e) {
    return Promise.reject(e);
  }
};
var useAuthRefresh = function useAuthRefresh(force) {
  if (!window.__BiliUser__) {
    if (force === true) {
      loadBiliUser().then(function () {
        window.__BiliUser__.refresh();
      });
    }
    return;
  }
  window.__BiliUser__.refresh();
};
var useAuthChange = function useAuthChange(callback, immediately) {
  if (!window.__BiliUser__) {
    var promise = loadBiliUser();
    promise.then(function () {
      window.__BiliUser__.watch(callback, immediately);
    });
    return function () {
      promise.then(function () {
        window.__BiliUser__.unWatch(callback);
      });
    };
  }
  window.__BiliUser__.watch(callback, immediately);
  return function () {
    window.__BiliUser__.unWatch(callback);
  };
};
var useAuthLogout = function useAuthLogout(callback, redirectUrl) {
  if (!window.__BiliUser__) {
    loadBiliUser().then(function () {
      window.__BiliUser__.logout(callback, redirectUrl);
    })["catch"](function () {
      console.warn("BiliUser is not found");
    });
    return;
  }
  window.__BiliUser__.logout(callback, redirectUrl);
};
var miniLogin;
var useAuthLogin = function useAuthLogin(config) {
  if (window.__BiliUser__) {
    var BiliUser = window.__BiliUser__;
    return new Promise(function (resolve, reject) {
      BiliUser.quickLogin(function (_ref) {
        var code = _ref.code;
        if (code === 0) {
          resolve();
          return;
        }
        reject();
      }, config);
    });
  }
  return new Promise(function (resolve, reject) {
    function showMiniLogin() {
      miniLogin.showComponent();
      miniLogin.addEventListener("success", function () {
        resolve();
        miniLogin.removeEventListener("success");
        miniLogin.removeEventListener("cancel");
      });
      miniLogin.addEventListener("cancel", function () {
        reject();
        miniLogin.removeEventListener("success");
        miniLogin.removeEventListener("cancel");
      });
    }
    if (miniLogin) {
      showMiniLogin();
      return;
    }
    loadMiniLogin().then(function (MiniLogin) {
      if (!MiniLogin) return reject("MiniLogin is not found");
      miniLogin = new MiniLogin(config);
      showMiniLogin();
    })["catch"](reject);
  });
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var useMeta = function useMeta(name) {
  if (typeof window === "undefined") return "";
  var meta = document.querySelector("meta[name=\"" + name + "\"]");
  if (meta != null && meta.content) {
    return meta.content;
  }
  return "";
};
var spmId = "";
var useSpmPrefix = function useSpmPrefix() {
  if (spmId) return spmId;
  spmId = useMeta("spm_prefix");
  return spmId || "0.0";
};

var loadReporter = function loadReporter() {
  try {
    if (window.ReporterPb) {
      return Promise.resolve(window.ReporterPb);
    }
    return Promise.resolve(loadScript("//s1.hdslb.com/bfs/seed/jinkela/short/reporter-pb/index.js", {
      lib: "ReporterPb"
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};
var useReporter = function useReporter(options) {
  return Promise.resolve(loadReporter()).then(function (Reporter) {
    return new Reporter(options);
  });
};
var noopReport = function noopReport(type, spm, data, options) {
  console.warn("[" + (typeof window === "undefined" ? "Node" : "Browser") + "]Miss reporter args: " + JSON.stringify({
    type: type,
    spm: spm,
    data: data,
    options: options
  }));
};
var bindGlobalReport = function bindGlobalReport(instKey) {
  var global = window;
  var spmPrefix = useSpmPrefix();
  var report = global[instKey].report.bind(global[instKey]);
  return function (type, spm, data, options) {
    if (typeof spm !== "string") {
      if (!spm.prefix) {
        spm = _extends({}, spm, {
          prefix: spmPrefix
        });
      }
    } else if (spm.split(".").length <= 3) {
      spm = spmPrefix + "." + spm;
    }
    return report(type, spm, data, options);
  };
};
var mirrorReport = function mirrorReport(type, spm, data, options) {
  var _window$biliMirror = window.biliMirror,
    customReportPb = _window$biliMirror.customReportPb,
    techReportPb = _window$biliMirror.techReportPb;
  var spmPrefix = "";
  var event = "";
  if (typeof spm !== "string") {
    event = [spm.c, spm.d, spm.e].filter(Boolean).join(".");
    if (spm.prefix) {
      spmPrefix = spm.prefix;
    }
  } else {
    var tokens = spm.split(".");
    // 如果前两位已经是带有spm前缀的话，分开赋值传
    if (!isNaN(Number(tokens[0])) && !isNaN(Number(tokens[1]))) {
      spmPrefix = tokens.splice(0, 2).join(".");
      event = tokens.join(".");
    } else {
      event = spm;
    }
  }
  if (type === "tech") {
    if (techReportPb) {
      techReportPb({
        eventId: event,
        msg: data,
        otherSpmId: spmPrefix
      });
      return;
    }
  } else if (customReportPb) {
    customReportPb({
      type: type,
      eventId: event,
      msg: data,
      otherSpmId: spmPrefix
    });
    return;
  }
  noopReport(type, spm, data, options);
};
/**
 * 使用上报函数，从window上的全局对象获取
 * @param config
 * @returns
 */
var useReportFunc = function useReportFunc(config) {
  if (typeof window === "undefined") return noopReport;
  var global = window;
  var globalInst = "";
  function check() {
    var reporter = global[globalInst];
    if (reporter != null && reporter.report) return true;
    return false;
  }
  if (typeof (config == null ? void 0 : config.globalInst) === "string") {
    globalInst = config.globalInst;
    if (check()) return bindGlobalReport(globalInst);
  }
  if ((config == null ? void 0 : config.mirror) !== false) {
    if (window.biliMirror) {
      return mirrorReport;
    }
  }
  globalInst = "__biliMirrorPbInstance__";
  if (check()) return bindGlobalReport(globalInst);
  return noopReport;
};
/**
 * 直接使用默认的上报函数
 * @param type
 * @param spm
 * @param data
 * @param options
 * @returns
 */
var useReport = function useReport(type, spm, data, options) {
  return useReportFunc()(type, spm, data, options);
};

var loadRequest = function loadRequest(type) {
  if (window.Unios) {
    return Promise.resolve(window.Unios);
  }
  var t = window.__LOAD_REQUEST_TYPE__ || type || "web";
  return loadScript("//s1.hdslb.com/bfs/seed/jinkela/short/unios/" + t + ".min.js", {
    lib: "Unios"
  });
};
var useRequest = function useRequest(config) {
  try {
    if (window.Unios) {
      return Promise.resolve(window.Unios.request(config));
    }
    return Promise.resolve(loadRequest()).then(function () {
      return window.Unios.request(config);
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var loadToast = function loadToast() {
  try {
    if (window.BToast) {
      return Promise.resolve(window.BToast);
    }
    return Promise.resolve(loadScript("//s1.hdslb.com/bfs/seed/jinkela/short/webui/toast/index.js", {
      lib: "BToast"
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};
var useToast = function useToast(content, duration, onClose) {
  try {
    if (window.BToast) {
      return Promise.resolve(window.BToast.show(content, duration, onClose));
    }
    return Promise.resolve(loadToast()).then(function () {
      return window.BToast.show(content, duration, onClose);
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

export { loadBiliUser, loadKvSDK, loadMiniLogin, loadReporter, loadRequest, loadScript, loadToast, useAuthChange, useAuthData, useAuthLogin, useAuthLogout, useAuthRefresh, useKv, useKvSync, useMeta, useReport, useReportFunc, useReporter, useRequest, useSpmPrefix, useToast };
